import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
// import { Grid, Typography, Stack, Button } from '@mui/material';
// import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';

import { getQuizList } from '../../../store/QuizSlice/QuizApi';
import { getAuthState } from '../../../store/AuthSlice';
import { useAppSelector } from '../../../hooks';
import { checkUserPermission } from '../../../helper';
import MobileHeader from '../../../components/Mobile/Header';
import PageHeader from './components/PageHeader';
// import MyQuizCard from '../MyQuiz/components/MyQuizCard';

const intialFilterData = {
  limit: 4,
  offset: 0,
};

const DashboardView: React.FC = () => {
  // const navigate = useNavigate();
  const dispatch = useDispatch();

  // Store
  // const quizState = useAppSelector(getQuizState);
  const authState = useAppSelector(getAuthState);

  // Permissions
  const viewQuizPermission = checkUserPermission(authState.user, {
    quiz: ['view'],
  });

  useEffect(() => {
    if (viewQuizPermission) {
      dispatch(getQuizList({ ...intialFilterData }));
    }
  }, []);

  return (
    <div>
      <MobileHeader leftContents={{ type: 'drawer' }} />
      <PageHeader />
      {/* <div style={{ padding: '15px' }}>
        <Stack direction="row" alignItems="flex-start">
          <Typography variant="h5" fontWeight={600} sx={{ mb: '15px' }}>
            My Quiz
          </Typography>
          {viewQuizPermission && (
            <Button
              endIcon={<DoubleArrowIcon />}
              color="secondary"
              sx={{ ml: '10px' }}
              onClick={() => navigate('/dashboard/my-quizzes')}
            >
              Explore All
            </Button>
          )}
        </Stack>
        {viewQuizPermission && (
          <div>
            <Grid container spacing={2}>
              {quizState.list.map((quiz, index) => (
                <Grid key={index} item xs={12} sm={6} md={6} lg={4} xl={3}>
                  <MyQuizCard quiz={quiz} />
                </Grid>
              ))}
            </Grid>
          </div>
        )}
      </div> */}
    </div>
  );
};

export default DashboardView;
